import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { HitSubStatusType } from './hit-sub-status-type.interface';

export class HitSubStatusTypeService {
   async getHitSubStatusTypes() {
      const response = await http.get<ApiResource<Array<HitSubStatusType>>>('/hit-sub-status-types', {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getHitSubStatusType() {
      throw Error('Method not implemented');
   }

   async postHitSubStatusType() {
      throw Error('Method not implemented');
   }

   async putHitSubStatusType() {
      throw Error('Method not implemented');
   }

   async deleteHitSubStatusType() {
      throw Error('Method not implemented');
   }
}
